<template>
  <div class="stepContainer">
    <common-new-header />
    <div class="step_con">
      <div class="layout common-main">
        <h2 v-if="courseInfo" class="common-main_title">{{ courseInfo.courseName }}</h2>
        <h1 class="common-main_num">机位号：<span>111</span></h1>
        <div class="common-main_content">
          <div class="common-main_content__body">
            <slot name="content"></slot>
          </div>
          <div class="common-main_content__tip" v-if="showTip">
            准考证号：1111111111111 身份证号：111111111111111111
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
    <common-footer />
  </div>
</template>

<script>
import { CommonNewHeader, CommonFooter } from '@components/common';
import { mapGetters } from 'vuex';
import { setPageTitle, isEmptyObject, parseNumber } from '@/utils';

export default {
  name: 'Wrapper',
  components: { CommonNewHeader, CommonFooter },
  computed: {
    ...mapGetters(['siteData'])
  },
  data() {
    return {
      courseInfo: null,
      showTip: true
    };
  },
  async mounted() {
    const { siteCourseID } = this.$route.query;

    if (this.$route.name !== 'Step1') {
      this.showTip = false;
    }
    const { flag } = this.$route.params;
    let _flag = flag === 'paidExam' ? '' : flag;

    const { majorID } = this.$categoryInfo;

    if (isEmptyObject(this.siteData)) {
      let params = {
        flag: _flag,
        majorID: majorID,
        siteCourseID: parseNumber(siteCourseID)
      };
      await this.$store
        .dispatch('getCurrentSiteInfo', params)
        .then((res) => {
          this.courseInfo = res.currentCourse;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    } else {
      this.courseInfo = this.siteData.currentCourse;
    }
    document.title = setPageTitle(this.courseInfo.siteCourseName);
  }
};
</script>

<style lang="scss" scoped>
.common-main {
  &_title {
    text-align: center;
    color: #1d82d4;
    font-weight: 700;
    line-height: 90px;
    padding: 20px 0 0 0;
    font-size: 24px;
  }

  &_num {
    text-align: center;
    color: #1f83d2;
    line-height: 60px;
    font-size: 48px;
    font-weight: 700;
    > span {
      color: #e7661a;
    }
  }

  &_content {
    width: 700px;
    margin: 0 auto;
    overflow: hidden;
    background: url('~@/assets/images/common/bei2.png') no-repeat;
    &__body {
      width: 440px;
      height: 270px;
      margin: 60px auto 0;
      border-radius: 4px;
      position: relative;
      border: 10px solid #3c8ed9;
      background-color: #fff;
    }

    &__tip {
      width: 440px;
      text-align: center;
      margin: 10px auto 0;
      color: #e67e23;
      font-size: 14px;
    }
  }
}
</style>
